import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { QuillModule } from 'ngx-quill';
import { SabisTextEditor2Component } from './sabis-texteditor2/text-editor.component';



@NgModule({
  declarations: [
    SabisTextEditor2Component
  ],
  imports: [
    CommonModule,
    FormsModule,
    QuillModule.forRoot()
  ],
  exports: [
    SabisTextEditor2Component,
    QuillModule
  ]
})
export class SabisEditor2Module { }
